import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Box, Button, Divider, TextField, Typography/*, TextField*/ } from '@mui/material';


import { ProfileFormData, useStep } from '../wizard/QuestionsForm'
// GetSubTitleFromTitleSubtitle moved to header
import { TextFieldDynamicRows } from '../../app/components/TextFieldDynamicRows';
import { MessageProfile } from '../MessageProfile';


// Define a stateless functional component as an arrow function
export const ReviewYourPin: React.FC = () => {
  const { step, data, updatedData, wizardData } = useStep()
  const { getValues, control, formState: { errors }, formState: { dirtyFields }, clearErrors, trigger } = useFormContext<ProfileFormData>();
  var formOverProfile = { ...data, ...updatedData.data, ...updatedData.profileDTO ?? {} }
  const formValues = getValues()
  return (

    <>
      <Controller
        name="comment"
        control={control}
        defaultValue={data.comment}
        render={({ field }) => (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <Box sx={{
                mb: 1.5,
                px: 1.5,
                py: 1,
                borderRadius: 2,
                backgroundColor: 'rgba(101, 110, 255, 0.06)',
                borderLeft: '3px solid #656EFF',
              }}>
                <Typography variant="body2" sx={{ color: '#444', fontWeight: 500 }}>
                  The personal info and story below will be visible to the public.
                </Typography>
              </Box>

              {/* Personal Info Section */}
              <Box sx={{
                borderRadius: 2,
                border: '1px solid rgba(164, 142, 233, 0.15)',
                mb: 1.5,
                overflow: 'hidden',
              }}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 1.5,
                  py: 0.75,
                  backgroundColor: 'rgba(101, 110, 255, 0.06)',
                  borderBottom: '1px solid rgba(164, 142, 233, 0.1)',
                }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Personal Info</Typography>
                  <Button type="submit" submit-attr="edit-personal-info" size="small" sx={{ textTransform: 'none', color: '#656EFF', minWidth: 'auto', fontSize: '0.75rem', py: 0, px: 1 }}>Edit</Button>
                </Box>
                <Box sx={{
                  p: 1.5,
                  display: 'flex',
                  justifyContent: 'center',
                  // Override MessageProfile's own box styling
                  '& > .MuiBox-root': {
                    border: 'none',
                    p: 1,
                    m: 0,
                    width: '100%',
                    maxWidth: 320,
                  },
                }}>
                  <MessageProfile hideUserAndLocationPinsForIncompleteProfile={!!!data.is_completed && !!!(formValues.location?.country && formValues.location?.zipCode)} profile={formOverProfile} renderUserName={() => {
                    return (
                      <Box flexGrow='10'>
                        <Controller
                          rules={{
                            required: 'Please enter your user name',
                          }}
                          name="name_public"
                          control={control}
                          defaultValue={data.name_public}
                          render={({ field }) => (
                            <TextField
                              sx={{
                                '& .MuiInputBase-root': {
                                  fontSize: '0.9rem',
                                  fontWeight: 600,
                                  backgroundColor: 'rgba(101, 110, 255, 0.05)',
                                  borderRadius: '8px',
                                  cursor: 'text',
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#656EFF',
                                  borderStyle: 'dashed',
                                  borderWidth: '1.5px',
                                },
                                '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#656EFF',
                                  borderStyle: 'solid',
                                },
                                '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                  borderColor: '#656EFF',
                                  borderStyle: 'solid',
                                  borderWidth: '2px',
                                },
                              }}
                              label="Edit your public username"
                              variant="outlined"
                              size="small"
                              fullWidth
                              error={!!errors["name_public"]}
                              helperText={errors.name_public ? errors.name_public.message : 'Tap to change your display name'}
                              value={field.value}
                              onChange={(event) => {
                                field.onChange(event.target.value)
                                clearErrors("name_public")
                                trigger("name_public")
                              }
                              }
                              FormHelperTextProps={{
                                sx: { color: !errors.name_public ? '#656EFF' : undefined, fontWeight: 500, fontSize: '0.7rem' }
                              }}
                            />
                          )
                          }
                        />
                      </Box>)
                  }} />
                </Box>
              </Box>

              {/* My Story Section */}
              <Box sx={{
                borderRadius: 2,
                border: '1px solid rgba(164, 142, 233, 0.15)',
                overflow: 'hidden',
              }}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  px: 1.5,
                  py: 0.75,
                  backgroundColor: 'rgba(101, 110, 255, 0.06)',
                  borderBottom: '1px solid rgba(164, 142, 233, 0.1)',
                }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.05em' }}>My Story</Typography>
                  <Button type="submit" submit-attr="edit-story" size="small" sx={{ textTransform: 'none', color: '#656EFF', minWidth: 'auto', fontSize: '0.75rem', py: 0, px: 1 }}>Edit</Button>
                </Box>
                <Box sx={{ p: 1.5 }}>
                  <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                    {field.value || <span style={{ color: '#aaa', fontStyle: 'italic' }}>No story added yet</span>}
                  </Typography>
                </Box>
              </Box>
            </div >
          </>
        )}
      />
    </>
  )
}